/* eslint-disable consistent-return */
/* eslint-disable import/no-named-as-default */

import autobind from 'autobind-decorator';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import User from '../../../../../helper/currentUser';
import { uploadToS3 } from '../../../../helper/fileUpload';
import Recorder from '../../../../helper/Recorder';
// import AudioPlayer from '../AudioCard/AudioPlayer';

const user = new User();

export default class AudioResponseHelper {
  constructor(audioComponent) {
    this.AC = audioComponent;
    if (window.location.protocol.indexOf('https') < 0 && window.location.hostname !== 'localhost') {
      // audioComponent.audioSupported(false);
    }
  }

  @autobind
  initiRecorder(callBack, audioSupported) {
    const self = this;
    try {
      // webkit shim
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      navigator.getUserMedia = navigator.getUserMedia
        || navigator.webkitGetUserMedia
        || navigator.mozGetUserMedia
        || navigator.msGetUserMedia;

      window.URL = window.URL || window.webkitURL;
      self.audio_context = new AudioContext();
      window.analytics
        && window.analytics.track('AUDIO_CONTEXT_SETUP', {
          'navigator.getUserMedia': navigator.getUserMedia ? 'available.' : 'not present!'
        });
    } catch (e) {
      SnackBarHelper.showSnackbar({
        label: 'No Audio record support in your browser / You didn\'t "Allow" on browser prompt.',
        duration: 3
      });
    }
    this.getAudioSupport(callBack, audioSupported);
  }

  @autobind
  getAudioSupport(callBack, audioSupported) {
    const self = this;
    navigator.getUserMedia(
      { audio: true },
      (stream) => {
        self.input = self.audio_context
          && self.audio_context.state !== 'closed'
          && self.audio_context.createMediaStreamSource(stream);
        // console.log('Media stream created.');
        self.audioStream = stream;

        if (
          !self.input
          || !self.input.context
          || !self.input.context.sampleRate
          || !navigator.getUserMedia
        ) {
          audioSupported(false);
          return false;
        }

        self.recorder = new Recorder(self.input, {
          numChannels: 1,
          workerPath: '/static/recorderWorker.js',
          mimeType: 'audio/wav'
        });

        audioSupported(true);
        callBack && callBack();

        window.analytics && window.analytics.track('RECORDER_INITIALISED');
      },
      (e) => {
        console.log('AUDIO', 'No live audio input: ' + e);
        SnackBarHelper.showSnackbar({
          label: 'No Audio record support in your browser / You didn\'t "Allow" on browser prompt.',
          duration: 3
        });
        // audioSupported(false);
      }
    );
  }

  @autobind
  recordAudio() {
    this.recorder && this.recorder.record && this.recorder.record();
  }

  @autobind
  stopRecording() {
    this.recorder && this.recorder.stop && this.recorder.stop();
  }

  @autobind
  clearRecording() {
    this.recorder && this.recorder.clear && this.recorder.clear();
  }

  exportWAV(callBack) {
    this.recorder.exportWAV(
      wavBlob => wavBlob && callBack(wavBlob, URL.createObjectURL(wavBlob)),
      'audio/wav',
      20000
    );
    this.clearRecording();
  }

  @autobind
  submitAudio(
    position,
    questionId,
    editResponse,
    cardId,
    wavData,
    uploadProgress,
    doneUploadingAudio
  ) {
    const fileName = user.id() + '_' + cardId + '_q' + position + 'v0_' + Date.now() + '.wav';
    const s3Url = global.constants.s3LyearnAssetsUrl + fileName;
    const uploadPromise = uploadToS3(s3Url, wavData, 'audio/wav', uploadProgress);

    window.analytics.track('FILE_UPLOAD_START', {
      fileName: s3Url
    });

    uploadPromise
      .then(() => {
        this.AC.setState(
          {
            responseToBeSubmitted: s3Url
          },
          () => {
            this.AC.props.saveOneResponse(this.AC.getResponse());
          }
        );
        window.analytics.track('FILE_UPLOAD_COMPLETE', {
          fileName: s3Url
        });
        doneUploadingAudio(s3Url);
      })
      .catch((reason) => {
        window.analytics.track('FILE_UPLOAD_FAILURE', {
          fileName: s3Url,
          error: reason
        });
      });
  }

  @autobind
  destroy() {
    this.audio_context && this.audio_context.state !== 'closed' && this.audio_context.close();
    this.audioStream && this.audioStream.stop && this.audioStream.stop();
  }

  @autobind
  audioReadyForUpload(wavData) {
    this.wavData = wavData;
  }
}
